import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http.service';
import { map, Observable, of } from 'rxjs';
import { Site } from '../../../shared/models/site';

@Injectable({
  providedIn: 'root',
})

export class MapHttpService {
  private _bingKey: string | undefined;
  private _authKey: string | undefined;
  private _projSite = new Map<number, string>(); // key = epsg ; value = proj
  private imageData: string = '';



  constructor(private http: HttpService) {}

  public getProj(site:Site): Observable<string> {
    const projData = this._projSite.get(Number(site.epsg));

    if (projData) return of(projData);

     return this.http.get<string>('Sites/proj4/' + site.epsg).pipe(
      map((responeProj) => {
        this._projSite.set(Number(site.epsg), responeProj);
        return responeProj;
      })
    );
  }

  async getMapBoxPublicKey(): Promise<string> {
        
      return this.http.get<string>('Config/mapBoxPublicKey').toPromise();
    }

  public getSiteGeoserverKey(siteId: number): Observable<string> {
    if (this._authKey) return of(this._authKey);

    return this.http.get<string>('Carte/authkey/' + siteId).pipe(
      map((respone) => {
        this._authKey = respone;
        return respone;
      })
    );
  }

  setImage(data: string) {
    this.imageData = data;
  }
  getImage(): string {
    return this.imageData;
  }
}
